<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Usuários"
      :headers="usuarioHeaders"
      :customHeaders="customHeaders"
      :items="usuarios"
      item-key="IdUsuario"
      :loading="loading"
      :setaSenha="true"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @abreModalSetaSenha="abreModalSetaSenha"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroUsuario 
      v-model="modalUsuario"
      :usuario="usuario"
      @usuarioAdicionado="usuarioAdicionado"
    />
    <ModalSetaSenha 
      v-model="dialogSenha"
      :usuario="null"
      :loading="loading"
      @setaSenhaSelected="setaSenhaItemSelected"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import Usuario from '@/domain/usuario/Usuario';
import ModalCadastroUsuario from '@/components/usuario/ModalCadastroUsuario';
import ModalSetaSenha from '@/components/usuario/ModalSetaSenha';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'UsuariosView',
  components: {
    GridSyclus,
    ModalCadastroUsuario,
    ModalSetaSenha,
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100016
      },
      usuarioHeaders: [
        { text: "ID", value: "IdUsuario" },
        { text: "Nome", value: "Descricao" },
        { text: "Status", value: "Status" }
      ],
      customHeaders: ["Status"],
      loading: false,
      modalUsuario: false,
      usuario: new Usuario(),
      // Modal Seta Senha
      dialogSenha: false,
      usuariosSelected: []
    }
  },
  computed: {
    ...mapGetters(['user', 'usuarios', 'isAdmin']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'fetchUsuariosSql',
      'fetchLayoutsSqlUsuario',
      'deleteUsuario',
      'setaSenhaUsuario'
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100016 });
      await this.fetchUsuariosSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalUsuario = true;
      this.usuario = Object.assign({}, new Usuario());
    },
    abreModalSetaSenha(payload) {
      if (payload.length) {
        this.dialogSenha = true;
        this.usuariosSelected = payload;
      } else {
        this.showNotification({ text: "Selecione pelo menos um usuário para setar a senha.", status: 'error' });
      }
    },
    editItemSelected(payload) {
      if (payload && payload.IdUsuario) {
        this.usuario = payload;
        this.modalUsuario = true;
      } else if (payload.length) {
        this.usuario = payload[payload.length - 1];
        this.modalUsuario = true;
      } else {
        this.showNotification({ text: "Selecione um usuário para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteUsuario(item.IdUsuario));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os usuários: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um usuario para excluir.', status: 'error' });
      }
    },
    setaSenhaItemSelected(senha) {
      if (this.usuariosSelected.length) {
        this.loading = true;
        let promises = [];

        this.usuariosSelected.forEach(item => {
          let usuarioSetaSenha = {
            IdUsuario: item.IdUsuario,
            novaSenha: senha
          }
          promises.push(this.setaSenhaUsuario(usuarioSetaSenha));
        });

        Promise.all(promises)
          .then(() => {
            this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            this.dialogSenha = false;
            this.loading = false;
            this.usuariosSelected = [];
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.showNotification({ text: `Ocorreu um erro ao setar a senha dos usuários: ${error}`, status: 'error' });
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos um usuário para setar a senha.`, status: 'error' });
      }
    },
    usuarioAdicionado() {
      this.usuario = Object.assign({}, new Usuario());
    }
  },
  created() {
    changePageTitle('Usuários');
    if (!this.isAdmin) return this.$router.go(-1);
  }
}
</script>

<style>

</style>